import React, { FC } from 'react';
import { Unstable_Grid2 as Grid, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { times } from 'lodash';

import { LoaderComponents } from 'components';

import TableHeader from './TableHeader';
import theme from 'theme';

const styles = {
  tableBodyRow: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: 'common.white',
    height: 65,
    '&:nth-of-type(even)': {
      backgroundColor: 'grey.50',
    },
  },
} as const;

interface Props {
  rows: number;
}

const MemberTableLoader: FC<Props> = ({ rows }) => {
  const { Image, Block, Content } = LoaderComponents;

  return (
    <Table>
      <TableHeader hasActions />
      <TableBody>
        {times(rows, (rowIndex: number) => (
          <TableRow sx={styles.tableBodyRow} key={rowIndex}>
            <TableCell />
            <TableCell colSpan={2}>
              <Grid container spacing={2} alignItems="center">
                <Grid>
                  <Image shape="circular" width={40} height={40} />
                </Grid>
                <Grid>
                  <Content height={15} maxWidth={160} />
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Block height={10} width={25} />
            </TableCell>
            <TableCell>
              <Content height={15} maxWidth={100} />
            </TableCell>
            <TableCell>
              <Content height={15} maxWidth={100} />
            </TableCell>
            <TableCell>
              <Content height={15} maxWidth={50} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default MemberTableLoader;
